import { FUND_CHART_APP_STATE_SLICE_KEY, FUND_CHART_CREATOR_STATE_KEYS, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { AppStateService } from 'NewAngular/services/app-state.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { FundChartUrlDeserializer } from 'ChartApp/ts/features/fund-chart-page-shared/fund-chart.serializers';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/app-state.service";
export class FundChartCreatorAppStateManager extends AppStateManager {
    constructor(appStateService) {
        super(appStateService);
        this.appStateService = appStateService;
    }
    initAppState() {
        if (!this.appStateService)
            return;
        this.appStateService.setStateSlice(FUND_CHART_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(FUND_CHART_CREATOR_STATE_KEYS);
        this.appStateService.setCustomUrlParamDeserializer(FundChartUrlDeserializer);
        this.appStateService.start();
    }
}
FundChartCreatorAppStateManager.ɵfac = function FundChartCreatorAppStateManager_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartCreatorAppStateManager)(i0.ɵɵinject(i1.AppStateService)); };
FundChartCreatorAppStateManager.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FundChartCreatorAppStateManager, factory: FundChartCreatorAppStateManager.ɵfac, providedIn: 'root' });
